import { client } from '@trello/graphql';
import { asString } from '@trello/browser';
import { clientVersion } from '@trello/config';
import ModelCache from 'app/scripts/db/model-cache.coffee';
import { featureFlagClient } from '@trello/feature-flag-client';
import { defaultStore } from 'app/gamma/src/defaultStore';
import rpc from 'app/scripts/network/rpc';

export const generateSupportDebugData = () => {
  // Strip the "_events" property from the ModelCache because it contains
  // circular references and can't be stringified.
  const { _events, ...modelCacheWithoutEvents } = ModelCache;

  const supportDebugData = {
    apolloCache: client.cache.extract(),
    browser: asString,
    features: featureFlagClient.all(),
    modelCache: modelCacheWithoutEvents,
    reduxStore: defaultStore.getState(),
    socket: {
      currentSubscriptions: rpc.currentSubscriptions,
      state:
        rpc.rpcSocket && rpc.rpcSocket.socket
          ? rpc.rpcSocket.socket.state
          : 'unknown',
    },
    version: clientVersion,
  };

  import(/* webpackChunkName: "download-support-debug-data" */ './downloadSupportDebugData').then(
    ({ downloadSupportDebugData }) => {
      downloadSupportDebugData(supportDebugData);
    },
  );

  return supportDebugData;
};
